var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E06A2C"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4B1A"
    },
    d: "M393.183,259.35l-281.226,42.877l202.952,202.952c79.419-18.704,144.556-74.392,176.256-147.892 L393.183,259.35z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M113.954,301.921c-0.097,0.657-0.565,1.126-1.176,1.126c-0.61,0-1.077-0.469-1.172-1.139 l-2.138-16.003l2.138-16.27c0.09-0.678,0.559-1.146,1.172-1.146c0.605,0,1.074,0.469,1.176,1.146l2.546,16.289L113.954,301.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M124.849,311.644c-0.102,0.696-0.605,1.183-1.229,1.183c-0.605,0-1.136-0.486-1.219-1.183 l-2.877-25.743l2.877-26.321c0.086-0.677,0.614-1.183,1.219-1.183c0.624,0,1.129,0.495,1.229,1.183l3.274,26.321L124.849,311.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M136.604,316.004c-0.083,0.836-0.71,1.431-1.464,1.431c-0.779,0-1.396-0.595-1.47-1.431 l-2.731-30.082l2.731-31.225c0.069-0.848,0.693-1.453,1.47-1.453c0.753,0,1.377,0.605,1.464,1.453l3.098,31.225L136.604,316.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M148.475,316.959c-0.086,0.958-0.836,1.684-1.727,1.684c-0.912,0-1.658-0.724-1.734-1.684 l-2.579-31.037l2.579-32.084c0.076-0.967,0.822-1.691,1.734-1.691c0.891,0,1.641,0.724,1.727,1.691l2.924,32.084L148.475,316.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M160.411,317.207c-0.062,1.114-0.931,1.939-1.958,1.939c-1.06,0-1.9-0.826-1.972-1.939 l-2.438-31.291l2.438-29.765c0.076-1.107,0.912-1.933,1.972-1.933c1.046,0,1.896,0.826,1.958,1.919l2.762,29.779L160.411,317.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M172.463,317.226v-0.017c-0.072,1.233-1.05,2.207-2.226,2.207c-1.179,0-2.157-0.977-2.226-2.189 l-2.276-31.291l2.276-48.426c0.069-1.233,1.046-2.207,2.226-2.207s2.157,0.977,2.226,2.189l2.579,48.445L172.463,317.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M184.425,317.207v-0.017c-0.072,1.364-1.15,2.448-2.484,2.448c-1.308,0-2.391-1.086-2.457-2.448 l-2.15-31.089l2.15-59.504c0.066-1.364,1.146-2.441,2.457-2.441c1.334,0,2.412,1.077,2.484,2.441l2.42,59.504L184.425,317.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M196.832,316.728v-0.017c-0.053,1.519-1.248,2.698-2.715,2.698s-2.662-1.179-2.715-2.679 l-1.995-30.77c0,0,1.995-64.462,1.995-64.481c0.057-1.5,1.248-2.701,2.715-2.701s2.665,1.202,2.715,2.701l2.253,64.481 L196.832,316.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M209.17,316.523c-0.057,1.651-1.352,2.946-2.963,2.946c-1.615,0-2.91-1.295-2.969-2.932 l-1.86-30.587l1.86-66.634c0.057-1.658,1.352-2.95,2.969-2.95c1.612,0,2.91,1.291,2.963,2.95l2.067,66.634L209.17,316.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M221.586,316.252v-0.017c-0.057,1.784-1.453,3.203-3.224,3.203c-1.745,0-3.17-1.417-3.203-3.184 l-1.71-30.294l1.691-64.931c0.05-1.81,1.47-3.21,3.22-3.21c1.77,0,3.167,1.4,3.224,3.21l1.919,64.931L221.586,316.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M234.101,316.073v-0.026c-0.029,1.945-1.565,3.441-3.462,3.441c-1.912,0-3.425-1.496-3.484-3.415 l-1.543-30.118l1.546-62.555c0.057-1.939,1.572-3.458,3.484-3.458c1.896,0,3.432,1.519,3.462,3.458l1.75,62.573L234.101,316.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M246.872,312.896l-0.155,2.95c-0.017,1.027-0.45,1.958-1.11,2.629 c-0.678,0.66-1.608,1.083-2.593,1.083c-1.146,0-2.157-0.526-2.85-1.357c-0.512-0.602-0.829-1.381-0.865-2.2 c-0.01-0.036-0.01-0.083-0.01-0.133c0,0-1.424-29.88-1.424-29.93l1.407-73.719l0.017-0.707c0.01-1.291,0.696-2.441,1.72-3.101 c0.574-0.383,1.252-0.605,2.008-0.605c0.743,0,1.446,0.231,2.034,0.638c0.998,0.667,1.651,1.789,1.67,3.072l1.565,74.459 L246.872,312.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F1F1"
    },
    d: "M259.281,315.459v-0.036c-0.026,2.177-1.81,3.953-3.967,3.953c-2.164,0-3.944-1.774-3.967-3.934 l-0.819-14.533l-0.803-14.922l1.622-80.798v-0.407c0.003-1.226,0.581-2.322,1.47-3.062c0.681-0.559,1.558-0.898,2.496-0.898 c0.746,0,1.439,0.205,2.031,0.552c1.129,0.707,1.919,1.958,1.955,3.389l1.757,81.22L259.281,315.459z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M366.501,319.455c0,0-99.828,0-99.931,0c-2.157-0.221-3.862-1.936-3.898-4.148v-114.4 c0.036-2.107,0.76-3.191,3.472-4.234c6.999-2.712,14.926-4.313,23.071-4.313c33.23,0,60.459,25.491,63.348,57.965 c4.277-1.784,9-2.801,13.938-2.801c19.899,0,36.031,16.141,36.031,36.054C402.532,303.487,386.398,319.455,366.501,319.455 L366.501,319.455z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.b0bb2cc3ff1fefef6d6f9369a6fc0969.svg";
export { ForwardRef as ReactComponent };